export default "__VITE_ASSET__Co6HdjC4__"